import { ecorEnv } from '@/../environments/environment';
import { Component, OnInit, signal, computed, inject, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-ecorr-footer',
    templateUrl: './ecorr-footer.component.html',
    standalone: true,
    imports: [CommonModule]
})
export class EcorrFooterComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    // Signal-based state management
    private _versionNumber = signal<string>('v5.0.1');
    private _hideVersion = signal<boolean>(false);

    // Computed properties
    versionNumber = computed(() => this._versionNumber());
    hideVersion = computed(() => this._hideVersion());

    constructor() { }

    ngOnInit(): void { 
        if (ecorEnv.isProd()) {
            this._hideVersion.set(true);
            this._versionNumber.set('');
        }
    }
}
